/* Left Sleeve theme: gallery, multi-buy mixer, sticky buy bar, cart drawer */
(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function formatMoney(cents) {
    const format = (window.theme && window.theme.moneyFormat) || '£{{amount}}';
    const value = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) =>
      key === 'amount_no_decimals' ? Math.round(cents / 100).toString() : value
    );
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const track = $('[data-gallery-track]', root);
    if (!track) return null;
    const slides = $$('.gallery__slide', track);
    const dotsWrap = $('[data-gallery-dots]', root);
    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', () => go(i));
      dotsWrap.appendChild(b);
      return b;
    });
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = (i) => {
      const n = (i + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    };
    const mark = () => dots.forEach((d, i) => d.classList.toggle('is-active', i === current()));
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    $('[data-gallery-prev]', root).addEventListener('click', () => go(current() - 1));
    $('[data-gallery-next]', root).addEventListener('click', () => go(current() + 1));
    if (slides.length < 2) $$('.gallery__arrow', root).forEach((b) => (b.hidden = true));
    mark();
    return {
      showColour(name, index) {
        const wanted = name.toLowerCase();
        let i = slides.findIndex((s) => s.dataset.alt === wanted);
        if (i < 0 && index < slides.length) i = index;
        if (i >= 0) go(i);
      }
    };
  }

  /* ---------- Multi-buy ---------- */
  function initProduct(section) {
    const gallery = initGallery($('[data-gallery]', section));
    const form = $('[data-bundle-form]', section);
    if (!form) return;
    const tiers = $$('[data-tier]', form);
    const coloursInput = $('[data-colours-input]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const errorEl = $('[data-bundle-error]', form);
    const pills = $$('.pill', section);
    const colourLabel = $('[data-colour-label]', section);
    let activeColour = pills[0] ? pills[0].dataset.colour : '';

    const selectedTier = () => tiers.find((t) => $('.tier__radio', t).checked) || tiers[0];

    const groupsOf = (tier) => $$('[data-group]', tier);

    function counts(group) {
      return $$('[data-mixer-row]', group).map((row) => ({
        row,
        name: row.dataset.colour,
        val: parseInt($('[data-mixer-val]', row).textContent, 10) || 0
      }));
    }

    function groupState(group) {
      const limit = parseInt(group.dataset.limit, 10);
      const list = counts(group);
      const total = list.reduce((sum, c) => sum + c.val, 0);
      return { limit, list, total, left: limit - total };
    }

    function setCount(row, val) {
      const el = $('[data-mixer-val]', row);
      el.textContent = val;
      el.classList.remove('bump');
      void el.offsetWidth; // restart the animation
      el.classList.add('bump');
    }

    function summary(group) {
      return counts(group).filter((c) => c.val > 0).map((c) => c.name + ' ×' + c.val).join(', ');
    }

    // How many badges the shopper still has to pick in this pack (0 when complete)
    function remaining(tier) {
      return groupsOf(tier).reduce((sum, g) => sum + groupState(g).left, 0);
    }

    function refreshGroup(group) {
      const { limit, list, total, left } = groupState(group);
      $('[data-group-count]', group).textContent = total + ' / ' + limit;
      group.classList.toggle('is-complete', left === 0);
      list.forEach((c) => {
        $('[data-step="-1"]', c.row).disabled = c.val === 0;
        $('[data-step="1"]', c.row).disabled = left === 0;
        // Once this section is full, fade out the colours that weren't picked
        c.row.classList.toggle('is-locked', left === 0 && c.val === 0);
      });
    }

    function syncForm() {
      const tier = selectedTier();
      if (!tier) return;
      tiers.forEach((t) => t.classList.toggle('is-selected', t === tier));
      const groups = groupsOf(tier);
      groups.forEach(refreshGroup);
      const left = remaining(tier);
      if (groups.length && left > 0) {
        addLabel.textContent = 'Choose ' + left + ' more badge' + (left > 1 ? 's' : '');
      } else {
        addLabel.textContent = 'Add to cart · ' + tier.dataset.price;
      }
      addBtn.classList.toggle('is-incomplete', groups.length > 0 && left > 0);
      if (!groups.length) coloursInput.value = activeColour + ' ×1';
      if (left === 0) showError('');
      updateRewards(tier);
      updateSticky(tier);
    }

    // Each + or − only changes that one colour; nothing else moves.
    form.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-step]');
      if (!btn) return;
      e.preventDefault();
      const group = btn.closest('[data-group]');
      const row = btn.closest('[data-mixer-row]');
      const { left } = groupState(group);
      const val = parseInt($('[data-mixer-val]', row).textContent, 10) || 0;
      const step = parseInt(btn.dataset.step, 10);
      if (step > 0 && left > 0) setCount(row, val + 1);
      if (step < 0 && val > 0) setCount(row, val - 1);
      syncForm();
    });

    form.addEventListener('change', (e) => {
      if (e.target.classList.contains('tier__radio')) syncForm();
    });

    // Top colourway pills: switch the photo and pick the colour for the single badge.
    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        activeColour = pill.dataset.colour;
        pills.forEach((p) => {
          const on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (colourLabel) colourLabel.textContent = activeColour;
        if (gallery) gallery.showColour(activeColour, parseInt(pill.dataset.index, 10));
        syncForm();
      });
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const tier = selectedTier();
      const groups = groupsOf(tier);
      let properties = { Colours: activeColour + ' ×1' };
      if (groups.length) {
        const left = remaining(tier);
        if (left > 0) {
          showError('Choose ' + left + ' more badge' + (left > 1 ? 's' : '') + ' to finish your pack.');
          const open = groups.find((g) => groupState(g).left > 0);
          if (open) open.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        properties = {};
        groups.forEach((g) => {
          properties[g.dataset.group === 'free' ? 'Free badges' : 'Badges'] = summary(g);
        });
      }
      showError('');
      addBtn.disabled = true;
      try {
        await Cart.add({ id: Number(tier.dataset.variant), quantity: 1, properties });
        Cart.open();
      } catch (err) {
        showError(err.message || 'Could not add to cart. Please try again.');
      } finally {
        addBtn.disabled = false;
      }
    });

    /* Reward cards: 0 = badges only, 1 = free badges, 2 = free shipping too */
    const rewards = $('[data-rewards]', form);
    function updateRewards(tier) {
      if (!rewards) return;
      const free = parseInt(tier.dataset.free, 10) || 0;
      const level = tier.dataset.ship === 'true' ? 2 : free > 0 ? 1 : 0;
      const prev = parseInt(rewards.dataset.level, 10);
      rewards.dataset.level = level;
      $$('[data-reward]', rewards).forEach((card) => {
        const n = parseInt(card.dataset.reward, 10);
        const on = n <= level;
        card.classList.toggle('is-unlocked', on);
        // Only animate cards that have just unlocked
        card.classList.toggle('just-unlocked', on && n > prev);
      });
      const freeSub = $('[data-reward-sub]', rewards);
      if (freeSub) freeSub.textContent = free > 0 ? '+' + free + ' free' : freeSub.dataset.locked;
      const shipSub = $('[data-reward="2"] .reward__sub', rewards);
      if (shipSub) shipSub.textContent = level === 2 ? shipSub.dataset.unlocked : shipSub.dataset.locked;
      const hint = $('[data-rewards-hint]', rewards);
      if (hint) hint.textContent = level === 2 ? 'All rewards unlocked' : level === 1 ? 'Go 10 + 3 for free UK shipping' : 'Pick a bigger pack to unlock more';
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    /* Sticky bar appears once the main button scrolls out of view */
    const sticky = $('[data-sticky-buy]', section);
    function updateSticky(tier) {
      if (!sticky) return;
      $('[data-sticky-title]', sticky).textContent = $('.tier__title', tier).textContent;
      $('[data-sticky-price]', sticky).textContent = tier.dataset.price;
    }
    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
      io.observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => form.requestSubmit());
    }

    syncForm();
  }

  /* ---------- Cart drawer ---------- */
  const Cart = {
    drawer: null,
    async request(url, body) {
      const res = await fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
      return data;
    },
    async add(item) {
      await this.request(window.theme.routes.cartAdd, { items: [item] });
      await this.refresh();
    },
    async change(key, quantity) {
      const cart = await this.request(window.theme.routes.cartChange, { id: key, quantity });
      this.render(cart);
    },
    async refresh() {
      const cart = await this.request(window.theme.routes.cartJs);
      this.render(cart);
      return cart;
    },
    render(cart) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      const lines = $('[data-cart-lines]');
      if (!lines) return;
      lines.innerHTML = '';
      if (!cart.items.length) {
        lines.innerHTML = '<p class="drawer__empty">Your cart is empty.</p>';
      }
      cart.items.forEach((item) => {
        const el = document.createElement('div');
        el.className = 'line';
        const props = Object.entries(item.properties || {})
          .filter(([k, v]) => v && k.charAt(0) !== '_')
          .map(([k, v]) => '<span class="line__meta">' + esc(k) + ': ' + esc(v) + '</span>')
          .join('');
        el.innerHTML =
          '<div class="line__img">' + (item.image ? '<img src="' + esc(item.image) + '" alt="">' : '') + '</div>' +
          '<div class="line__info">' +
            '<span class="line__title">' + esc(item.product_title) + '</span>' +
            (item.variant_title ? '<span class="line__meta">' + esc(item.variant_title) + '</span>' : '') +
            props +
            '<span class="stepper" style="justify-self:start;margin-top:6px">' +
              '<button type="button" class="stepper__btn" data-q="-1" aria-label="Decrease">−</button>' +
              '<span class="stepper__val">' + item.quantity + '</span>' +
              '<button type="button" class="stepper__btn" data-q="1" aria-label="Increase">+</button>' +
            '</span>' +
          '</div>' +
          '<strong class="line__price">' + formatMoney(item.final_line_price) + '</strong>';
        $$('[data-q]', el).forEach((b) =>
          b.addEventListener('click', () => this.change(item.key, Math.max(0, item.quantity + Number(b.dataset.q))))
        );
        lines.appendChild(el);
      });
      $('[data-cart-total]').textContent = formatMoney(cart.total_price);
      const note = $('[data-cart-note]');
      const freeShip = cart.items.some((i) => /10/.test(i.variant_title || ''));
      note.textContent = freeShip ? 'Free UK shipping unlocked' : (window.theme.freeShippingNote || '');
    },
    open() {
      this.drawer.hidden = false;
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.drawer.hidden = true;
      document.body.style.overflow = '';
    }
  };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  document.addEventListener('DOMContentLoaded', () => {
    Cart.drawer = $('[data-cart-drawer]');
    $$('[data-cart-open]').forEach((a) =>
      a.addEventListener('click', async (e) => {
        e.preventDefault();
        await Cart.refresh();
        Cart.open();
      })
    );
    $$('[data-cart-close]').forEach((el) => el.addEventListener('click', () => Cart.close()));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && Cart.close());
    $$('[data-product-section]').forEach(initProduct);

    // Fade sections in as they scroll into view
    const reveal = $$('.showcase .h2, .rail__card, .steps__item, .faq .h2, .faq .accordion, .cta .h2, .cta .btn');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px' });
      reveal.forEach((el, i) => { el.classList.add('reveal'); el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
    }
  });

  window.LeftSleeveCart = Cart;
})();
